import React, { Component } from 'react';
import Header from './../../Header';
import { Link, Redirect } from "react-router-dom";
import $ from 'jquery';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import 'react-datepicker/dist/react-datepicker.css';
import Pagination from "react-js-pagination";
class Snippets extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            snippet_date: [],
            // snippet_date_name: '',
            snippet_date_name: 'all',
            // snippet_assign_to: '',
            snippet_assign_to: [has_local_data ? localdata.user_id : ''],
            total_er: [],
            owners: [],
            assign_to: [],
            description: '',
            snippet_search: '',
            userAuthKey: has_local_data ? localdata.user_key : '',
            apiUrl: this.decryptconfigdata('apiUrl'),
            userId: has_local_data ? localdata.user_id : '',
            recentlyview: localStorage.getItem('recentlyview') ? localStorage.getItem('recentlyview').split(',') : [],
            activePage: 1,
            item_count: '',
            loading: 1,
            isLoadMore: 1,
            snippet_order_by: 'desc',
            snippet_order_column: 'last_updated_date'
        };
        this.searchChange = this.searchChange.bind(this);
        this.onChange = this.onChange.bind(this);
        this.multiselectionChange = this.multiselectionChange.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    rawjsonparse(findresponse, flg) {
        return findresponse;
    }

    loadMorecount() {
        if (this.state.item_count > 0) {
            if (this.state.item_count >= 20) {
                if (this.state.isLoadMore != 2) {
                    if (this.state.isLoadMore == 1) {
                        return (
                            <div class="pagination-muvi" id="section07">
                                <div class="load_more" onClick={() => this.loadMore(this.state.activePage)}><span></span><span></span><span></span></div>
                            </div>
                        )
                    } else {
                        return (
                            <div class="pagination-muvi" id="section07">
                                <div class="lds-ripple"><div></div><div></div></div>
                            </div>
                        )
                    }
                }
            }
        } else {
            return (
                <div className="text-center" style={{ color: "#333" }}>No Data Found</div>
            )
        }
    }

    multiselectionChange(value, id) {
        this.setState({ [id]: value, activePage: 1 }, function () {
            this.ListER();
        });
    }

    searchChange(event) {
        var obj = this;
        this.setState({ snippet_search: event.target.value, activePage: 1 });
        //Delaying the function execute
        if (this.timer) {
            window.clearTimeout(this.timer);
        }
        this.timer = window.setTimeout(function () {
            //Execute the function code here...
            obj.ListER();
        }, 500);
    }

    onChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    Reset() {
        var all_filters = this.getAllfilterKeys();
        for (var key in all_filters) {
            localStorage.setItem(all_filters[key], '');
            this.setState({ [all_filters[key]]: '', activePage: 1 });
        }
        var obj = this;
        setTimeout(function () {
            obj.ListER();
        }, 100);
    }

    handlePageChange(pageNumber = 1) {
        var totalPages = Math.ceil(this.state.item_count / 20);
        if (this.state.activePage != pageNumber) {
            $(document).ready(function () {
                $('.pages').addClass('disabled');
            });
        this.setState({ activePage: pageNumber, setPage: 'no' });  
        fetch(this.state.apiUrl + '/ErRest/ListSnippets/page/' + pageNumber + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                    $(document).ready(function () {
                        $('.pages').removeClass('disabled');
                        if (pageNumber == 1) {
                            $('.first_page').addClass('disabled');
                            $('.prev_page').addClass('disabled');
                        }
                        if (pageNumber == totalPages) {
                            $('.next_page').addClass('disabled');
                            $('.last_page').addClass('disabled');
                        }
                    });
                this.setState({
                    total_er: findresponse.total_er,
                    offset: findresponse.offset,
                    off_count: findresponse.off_count,
                    setPage: 'yes'
                })
            })
        }
    }

    loadMore(pageNumber) {
        this.setState({ isLoadMore: 0 })
        pageNumber = pageNumber + 1;
        this.setState({ activePage: pageNumber });
        fetch(this.state.apiUrl + '/ErRest/ListSnippets/page/' + pageNumber + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.total_er.length == 0) {
                    this.setState({
                        isLoadMore: 2
                    })
                } else {
                    this.setState({
                        isLoadMore: 1
                    })
                }
                this.setState({
                    total_er: this.state.total_er.concat(findresponse.total_er),
                })
            })
    }

    ListER(page = 1) {
        document.getElementById('loader-new').classList.remove("hidden");
        document.getElementById('list_check').classList.add("hidden");
        fetch(this.state.apiUrl + '/ErRest/ListSnippets/page/' + page + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                document.getElementById('loader-new').classList.add("hidden");
                document.getElementById('list_check').classList.remove("hidden");
                this.setState({
                    total_er: findresponse.total_er,
                    config: findresponse.config,
                    owners: findresponse.owners,
                    loading: 0,
                    item_count: findresponse.item_count,
                    snippet_date: findresponse.snippet_date,
                    isLoadMore: 1,
                    offset: findresponse.offset,
                    off_count: findresponse.off_count,
                    setPage: 'yes'
                })
            })
    }

    jumpSubmit(event) {
        var obj = this;
        if (event.key == 'Enter') {
                if (isNaN(event.target.value)) {
                    this.setState({ search: event.target.value, activePage: 1 });
                    //Delaying the function execute
                    if (this.timer) {
                        window.clearTimeout(this.timer);
                    }
                    this.timer = window.setTimeout(function () {
                        //Execute the function code here...
                        obj.ListER();
                    }, 500);
                }
                else {
                fetch(this.state.apiUrl + '/ErRest/viewEr/userAuthKey/' + this.state.userAuthKey + "/id/" + event.target.value + "/is_snippet/1")
                    .then((Response) => Response.json())
                    .then((responseJson) => {
                        responseJson = this.rawjsonparse(responseJson, 1);
                            if (responseJson.er.id) {
                        this.props.history.push('/viewEr/' + responseJson.er.id);
                            }
                            else obj.ListER();
                    })
            }
        }
    }

    onToggle(unique_id) {
        if (document.getElementById('showmore' + unique_id).innerHTML == '<i class="fal fa-angle-down"></i>') {
            document.getElementById('showmore' + unique_id).innerHTML = '<i class="fal fa-angle-up"></i>'
        } else {
            document.getElementById('showmore' + unique_id).innerHTML = '<i class="fal fa-angle-down"></i>'
        }
    }

    onTogglemob(unique_id) {
        if (document.getElementById('showmoremob' + unique_id).innerHTML == '<i class="fal fa-angle-down"></i>') {
            document.getElementById('showmoremob' + unique_id).innerHTML = '<i class="fal fa-angle-up"></i>'
        } else {
            document.getElementById('showmoremob' + unique_id).innerHTML = '<i class="fal fa-angle-down"></i>'
    }
    }

    goToSnippetDetails(id, assigned_to, owner) {
        window.location.href = '/viewSnippet/' + id;
        }

    getUserRows() {
            return (
                <div>
                <div class="loader-new" id="loader-new"></div>
                <div class="list_check hidden" id="list_check">
                        <div class="tickets hidden-sm">
                        <ul class="tickets_head">
                            <li class="intra_col_10 padding_left_12" id="col_id">ID</li>
                            <li class="intra_col_40" id="col_title">Snippets</li>
                            <li class="intra_col_25" id="col_assign_to">Owner</li>
                            <li class="intra_col_25" id="col_priority">Week</li>
                            </ul>
                            {
                            this.state.total_er.map((value, sequence) =>
                                    <ul class="tickets_number">
                                    {
                                        value.value.map((er, val) =>
                                            val == 0 ? <span>
                                                <li class="intra_col_10 padding_left_10 er_color">
                                                    <a href={`/viewSnippet/${er.unique_snippet_id}`}>
                                                        {value.cont}
                                                    </a>
                                        </li>
                                                <li class="intra_col_40"><a href={`/viewSnippet/${er.unique_snippet_id}`} name={"max"} className=""><span dangerouslySetInnerHTML={{ __html: er.title }}></span></a>{val == 0 && value.value.length > 1 ? <span class="snipet"><button class="showmore_button" id={"showmore" + er.unique_snippet_id} data-toggle={"collapse"} data-target={"#collapseExample" + er.unique_snippet_id} aria-expanded="false" aria-controls={"collapseExample" + er.unique_snippet_id} onClick={() => this.onToggle(er.unique_snippet_id)} ><i class="fal fa-angle-down"></i></button>
                                                <div class={"collapse"} id={"collapseExample" + value.key}>
                                                {
                                                    value.value.map((er, val) =>
                                                                val != 0 ? <span class="snippet_note">
                                                            <li class="intra_col_10 padding_left_10 er_color hidden">
                                                                {val + 1}
                                                                    </li><a href={`/viewSnippet/${er.unique_snippet_id}`} name={"max"} className=""><span dangerouslySetInnerHTML={{ __html: er.title }}></span></a>
                                                            <li class="intra_col_25 text-inded hidden">{er.assign}</li>
                                                                    <li class="intra_col_25 text-inded hidden">{er.from_date + ' / ' + er.to_date}</li>
                                                            <br></br>
                                                        </span> : ''
                                                    )}
                                            </div></span>
                                                : ''}</li>
                                                <li class="intra_col_25 text-inded"><Link key={val} to={`/viewEmployee/${er.user_id}`} name={"max"}>{er.assign}</Link></li>
                                                <li class="intra_col_25">{er.from_date + ' / ' + er.to_date}</li>
                                                <br></br>
                                            </span> : ''
                                        )
                                    }
                                    </ul>
                                )
                            }
                        </div>
                    <div class="tickets_mob er_list hidden-md">
                    {
                    this.state.total_er.map((value) =>
                        <div class="list_mob">
                            {
                                value.value.map((er, val) =>
                                    val == 0 ?
                            <span>
                                <h4 class="list_title">
                                <div class="text-inded snippet_x">
                                                            <span onClick={() => this.goToSnippetDetails(er.unique_snippet_id)} dangerouslySetInnerHTML={{ __html: er.title }}></span>{val == 0 && value.value.length > 1 ? <span class="snipet"><button class="showmore_button" id={"showmoremob" + er.unique_snippet_id} data-toggle={"collapse"} data-target={"#collapseExamplemob" + er.unique_snippet_id} aria-expanded="false" aria-controls={"collapseExamplemob" + er.unique_snippet_id} onClick={() => this.onTogglemob(er.unique_snippet_id)} ><i class="fal fa-angle-down"></i></button>
                                                <div class={"collapse"} id={"collapseExamplemob" + value.key}>
                                                {
                                                    value.value.map((er, val) =>
                                                        val != 0 ? <span>
                                                            <div><span dangerouslySetInnerHTML={{ __html: er.title }}></span></div>
                                                            
                                                        </span> : ''
                                                    )}
                                            </div></span>
                                                : ''}
                    </div>
                            </h4>
                            <div class="section">
                                <div class="wrap pull-left">
                                    <label>#Id:</label><span>{er.id}</span>
                </div>
                                <div class="wrap pull-right">
                                    <label>Owner</label>
                                                            <div class="text-capitalize"><Link key={val} to={`/viewEmployee/${er.user_id}`} name={"max"}>{er.assign}</Link></div>
                                </div>
                            </div>
                            <div class="section gry">
                                <div class="wrap snip">
                                    <label>Week</label><span>{er.from_date + ' / ' + er.to_date}</span>
                                </div>
                            </div>
                            </span>
                                                : '')}
                            </div>
                            )}
                        </div>
                    {this.state.item_count > 0 ? <div class="pagination-muvi">
                        <Pagination
                            itemClass={'pages'}
                            itemClassFirst={'first_page'}
                            itemClassPrev={'prev_page'}
                            itemClassNext={'next_page'}
                            itemClassLast={'last_page'}
                            activePage={this.state.activePage}
                            itemsCountPerPage={20}
                            totalItemsCount={this.state.item_count}
                            pageRangeDisplayed={5}
                            onChange={this.state.setPage == 'yes' ? this.handlePageChange : ''}
                        />
                        <div style={{ color: "#333" }}>
                            {(this.state.offset + 1) + ' - ' + (this.state.offset + this.state.off_count)} of {this.state.item_count}
                </div>
                    </div> : <div className="text-center" style={{ color: "#333" }}>No Data Found</div>}
                    {/* {this.loadMorecount()} */}
            </div>
            </div>
            )
        }

    getAllfilterKeys() {
        var filter_keys = ["snippet_assign_to", "snippet_search", "snippet_date_name",];
        return filter_keys;
    }

    getmultiplefilterkeys() {
        var filter_keys = ["snippet_assign_to", "snippet_date_name"];
        return filter_keys;
    }

    goToErDetails(id) {
        window.location.href = '/viewEr/' + id;
    }

    componentDidMount() {
        var obj = this;
        document.title = "Intranet | Snippets";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }

        //End
        setTimeout(function () {
            obj.ListER();
        }, 100);
        $('.searchTicket.dept').on('click', function () {
            $(this).closest('.customer').find('.filter_dept').slideToggle('slow');
        });
    }
    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        return (
            <div>
                <Header brecum_name="ER" brecum_page="Snippets" />
                <div class="right_col">
                    <section class="customer">
                        <div id="exTab1" class="container">
                            <ul class="nav nav-pills pull-left border_less hidden-sm">
                                <li class="">
                                    <Link to={`/snippets/`} name={"max"} >Snippets</Link>
                                </li>
                            </ul>
                            <div class="tab-content er_content clearfix">
                                <div class="tab-pane active" id="Leads">
                                    <div class="top-row m_t_20 snipet_bro">
                                        <div class="left-section btn-muvi pull-left">
                                            <a href="/AddTaskEr" class="btn btn-sky mob">
                                                <span class="hidden-sm">Add My Snippet</span>
                                                <span class="mob_icon_plus hidden-md">
                                                    <i class="fal fa-plus"></i>
                                                </span>
                                            </a>
                                        </div>
                                        <div class="right-section er_box">
                                        <div class="form-horizontal er_cal_icon" action="/action_page.php">
                                            <div class="mob_filter filter_dept">
                                                    <div class="col-sm-3 col-xs-12">
                                                        {/* <label>Owner</label> */}
                                                <div class="filter">
                                                    <MuiThemeProvider muiTheme={getMuiTheme()}>
                                                        <SelectField
                                                            multiple
                                                            fullWidth={true}
                                                            value={this.state.snippet_assign_to}
                                                            onChange={(event, index, value) => this.multiselectionChange(value, "snippet_assign_to")}
                                                            maxHeight={200}
                                                        >
                                                            <MenuItem value={this.state.userId} primaryText='[Myself]' />
                                                            {this.state.owners.map((dynamicData, key) =>
                                                                <MenuItem value={dynamicData.id} key={key} primaryText={dynamicData.name} />)
                                                            }
                                                        </SelectField>
                                                    </MuiThemeProvider>
                                                </div>
                                            </div>
                                                    <div class="col-sm-3 col-xs-12">
                                                        {/* <label>Date</label> */}
                                                <div class="filter">
                                                    <MuiThemeProvider muiTheme={getMuiTheme()}>
                                                        <SelectField
                                                            fullWidth={true}
                                                            value={this.state.snippet_date_name}
                                                            onChange={(event, index, value) => this.multiselectionChange(value, "snippet_date_name")}
                                                            maxHeight={200}
                                                        >
                                                            <MenuItem value='all' primaryText={'All'} />
                                                            {this.state.snippet_date.map((dynamicData) =>
                                                                <MenuItem value={dynamicData.key} key={dynamicData.key} primaryText={dynamicData.value} />)
                                                            }
                                                        </SelectField>
                                                    </MuiThemeProvider>
                                                </div>
                                            </div>

                                                    <div class="col-sm-1 filter_save">
                                                <div className="btn-muvi">
                                                    <button className="btn btn-blue" onClick={() => this.Reset()}>Reset</button>

                                                </div>
                                            </div>
                                        </div>
                                                <div class="col-md-5 col-xs-12 padding_less">
                                                <div class="searchTicket emp_dept">
                                                    <input type="text" value={this.state.snippet_search} class="form-control" name="snippet_search" id="snippet_search" placeholder="Search By Snippets" onChange={this.searchChange} onKeyPress={this.jumpSubmit.bind(this)} />
                                                    <button type="submit"><i class="fa fa-search"></i></button>
                                    </div>
                                                <div class="searchTicket filter dept hidden-md"><i class="fal fa-filter"></i></div>
                                                                </div>
                                                                </div>
                                                                </div>
                                                            </div>
                                    {this.getUserRows()}
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        );
    }

}
export default Snippets;


// WEBPACK FOOTER //
// ./src/components/er/Snippets.js